/* eslint-disable */
// Custom mutations without problematic relationships

export const createMovieReviewCustom = /* GraphQL */ `
  mutation CreateMovieReview(
    $input: CreateMovieReviewInput!
    $condition: ModelMovieReviewConditionInput
  ) {
    createMovieReview(input: $input, condition: $condition) {
      id
      movieID
      authorID
      rating
      review
      ratingSystem
      emoji
      status
      createdAt
      updatedAt
      likesCount
      __typename
    }
  }
`;

export const createShowReviewCustom = /* GraphQL */ `
  mutation CreateShowReview(
    $input: CreateShowReviewInput!
    $condition: ModelShowReviewConditionInput
  ) {
    createShowReview(input: $input, condition: $condition) {
      id
      showID
      authorID
      rating
      review
      ratingSystem
      emoji
      status
      createdAt
      updatedAt
      likesCount
      __typename
    }
  }
`;

export const updateMovieReviewCustom = /* GraphQL */ `
  mutation UpdateMovieReview(
    $input: UpdateMovieReviewInput!
    $condition: ModelMovieReviewConditionInput
  ) {
    updateMovieReview(input: $input, condition: $condition) {
      id
      movieID
      authorID
      rating
      review
      ratingSystem
      emoji
      status
      createdAt
      updatedAt
      likesCount
      __typename
    }
  }
`;

export const updateShowReviewCustom = /* GraphQL */ `
  mutation UpdateShowReview(
    $input: UpdateShowReviewInput!
    $condition: ModelShowReviewConditionInput
  ) {
    updateShowReview(input: $input, condition: $condition) {
      id
      showID
      authorID
      rating
      review
      ratingSystem
      emoji
      status
      createdAt
      updatedAt
      likesCount
      __typename
    }
  }
`;